// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.styles_wrapper__1fL4B {
  display: flex;
  justify-content: center;
  padding: 0.5em 0;
  width: 100%;
  color: rgba(0, 0, 0, 0.54);
  position: relative;
}

.styles_yellowBorder__albDr {
  border: 1px solid #ff9315 !important;
}

div.styles_container__8jK\\+U {
  width: 100%;
}

.styles_disabled__\\+E1GT {
  pointer-events: none;
  opacity: 0.6;
  display: none;
}

.styles_inputError__RZ2os {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_buttonSelect__uE7sE {
  border: 0;
  border-radius: 4px;
  width: 100%;
  padding: 6px 8px;
  position: relative;
  text-align: right;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  width: 100%;
  height: 44px;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  color: #535353;
  margin-right: 0 !important;
}

.styles_buttonSelect__uE7sE:hover {
  cursor: pointer;
}

.styles_buttonSelect__uE7sE::after {
  position: absolute;
  left: 8px;
  top: 25%;
  content: '\\276C';
  transform: rotate(90deg);
  margin-top: 2px;
}

.styles_buttonSelect__uE7sE.styles_ltr__QN6X0::after {
  transform: rotate(270deg);

}

.styles_buttonSelect__uE7sE.styles_expanded__Tppjc::after {
  content: '\\276D';
}

.styles_ul__sVJdn {
  border: 1px solid #eeeeee;
}

.styles_ul__sVJdn.styles_options__dGDut {
  border: 1px solid #fafafa;
  display: none;
  list-style: none;
  padding: 4px 0;
  margin-top: -4px;
  position: absolute;
  top: 100%;
  right: 0;
  width: inherit;
  height: auto;
  z-index: 1000;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  overflow: auto;
  height: auto;
  max-height: 200px;
  box-shadow: 0 9px 28px 8px rgb(0 0 0 / 5%), 0 6px 16px rgb(0 0 0 / 8%),
    0 3px 6px -4px rgb(0 0 0 / 12%);
  /* identical to box height, or 143% */

  color: #535353;
  scrollbar-color: #e3e3e3 transparent;
  scrollbar-width: 5px;
}

.styles_ul__sVJdn.styles_options__dGDut::-webkit-scrollbar {
  width: 5px;
}

.styles_ul__sVJdn.styles_options__dGDut::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
  border-radius: 100px;
  height: 5px;
}

.styles_ul__sVJdn.styles_show__goRZy {
  display: block;

}

.styles_ul__sVJdn.styles_options__dGDut li {
  padding: 6px 10px;
}

.styles_ul__sVJdn.styles_options__dGDut li:active,
.styles_ul__sVJdn.styles_options__dGDut li:focus,
.styles_ul__sVJdn.styles_options__dGDut li:hover,
.styles_ul__sVJdn.styles_options__dGDut li[aria-selected='true'] {

  cursor: pointer;
}

.styles_ul__sVJdn.styles_options__dGDut li:nth-child(1):active,
.styles_ul__sVJdn.styles_options__dGDut li:nth-child(1):focus,
.styles_ul__sVJdn.styles_options__dGDut li:nth-child(1):hover,
.styles_ul__sVJdn.styles_options__dGDut li:nth-child(1)[aria-selected='true'] {

  cursor: pointer;
}

.styles_titleStyle__9pt4O {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Select/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;;EAEZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;;EAErC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,aAAa;;EAEb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB;mCACiC;EACjC,qCAAqC;;EAErC,cAAc;EACd,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;;AAEhB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["div.wrapper {\n  display: flex;\n  justify-content: center;\n  padding: 0.5em 0;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.54);\n  position: relative;\n}\n\n.yellowBorder {\n  border: 1px solid #ff9315 !important;\n}\n\ndiv.container {\n  width: 100%;\n}\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.6;\n  display: none;\n}\n\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n}\n\n.buttonSelect {\n  border: 0;\n  border-radius: 4px;\n  width: 100%;\n  padding: 6px 8px;\n  position: relative;\n  text-align: right;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #eeeeee;\n  width: 100%;\n  height: 44px;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  /* identical to box height, or 143% */\n\n  color: #535353;\n  margin-right: 0 !important;\n}\n\n.buttonSelect:hover {\n  cursor: pointer;\n}\n\n.buttonSelect::after {\n  position: absolute;\n  left: 8px;\n  top: 25%;\n  content: '\\276C';\n  transform: rotate(90deg);\n  margin-top: 2px;\n}\n\n.buttonSelect.ltr::after {\n  transform: rotate(270deg);\n\n}\n\n.buttonSelect.expanded::after {\n  content: '\\276D';\n}\n\n.ul {\n  border: 1px solid #eeeeee;\n}\n\n.ul.options {\n  border: 1px solid #fafafa;\n  display: none;\n  list-style: none;\n  padding: 4px 0;\n  margin-top: -4px;\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: inherit;\n  height: auto;\n  z-index: 1000;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  overflow: auto;\n  height: auto;\n  max-height: 200px;\n  box-shadow: 0 9px 28px 8px rgb(0 0 0 / 5%), 0 6px 16px rgb(0 0 0 / 8%),\n    0 3px 6px -4px rgb(0 0 0 / 12%);\n  /* identical to box height, or 143% */\n\n  color: #535353;\n  scrollbar-color: #e3e3e3 transparent;\n  scrollbar-width: 5px;\n}\n\n.ul.options::-webkit-scrollbar {\n  width: 5px;\n}\n\n.ul.options::-webkit-scrollbar-thumb {\n  background-color: #e3e3e3;\n  border-radius: 100px;\n  height: 5px;\n}\n\n.ul.show {\n  display: block;\n\n}\n\n.ul.options li {\n  padding: 6px 10px;\n}\n\n.ul.options li:active,\n.ul.options li:focus,\n.ul.options li:hover,\n.ul.options li[aria-selected='true'] {\n\n  cursor: pointer;\n}\n\n.ul.options li:nth-child(1):active,\n.ul.options li:nth-child(1):focus,\n.ul.options li:nth-child(1):hover,\n.ul.options li:nth-child(1)[aria-selected='true'] {\n\n  cursor: pointer;\n}\n\n.titleStyle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n  margin-bottom: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__1fL4B`,
	"yellowBorder": `styles_yellowBorder__albDr`,
	"container": `styles_container__8jK+U`,
	"disabled": `styles_disabled__+E1GT`,
	"inputError": `styles_inputError__RZ2os`,
	"buttonSelect": `styles_buttonSelect__uE7sE`,
	"ltr": `styles_ltr__QN6X0`,
	"expanded": `styles_expanded__Tppjc`,
	"ul": `styles_ul__sVJdn`,
	"options": `styles_options__dGDut`,
	"show": `styles_show__goRZy`,
	"titleStyle": `styles_titleStyle__9pt4O`
};
export default ___CSS_LOADER_EXPORT___;
